module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticClass: "goBack",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回上一级")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          attrs: {
            "data": scope.row.tbEventMemberList,
            "border": "",
            "stripe": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "member",
            "label": "队员名"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "状态"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scoped) {
              return [(scoped.row.state == 0) ? _c('div', [_vm._v("待审批")]) : _vm._e(), _vm._v(" "), (scoped.row.state == 1) ? _c('div', [_vm._v("已入队")]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jointime",
            "label": "加入时间"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": "团队名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "队徽"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "100px",
            "height": "100px"
          },
          attrs: {
            "src": 'http://zlesp.zlydgy.cn:8091/images/' + scope.row.teamImgurl,
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "teamleader",
      "label": "队长姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "releasetime",
      "label": "创建时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "signature",
      "label": "签名"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7362d4a4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/gameModule/gameIteminfo.vue
// module id = 619
// module chunks = 70